import React, { useState,useEffect } from "react";
import {Link,useNavigate} from 'react-router-dom'
import "./termsOfUsePage.css"; // Make sure to import the CSS file
import Header from "../../components/common/header";
import Footer from "../../components/common/footer";
import { useUser } from "../../contexts/userContext";
import { useCart } from "../../contexts/cartContext";

const TermsOfUsePage = () => {
  const navigate = useNavigate();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  const { checkSessionTokenExpirationStatus, handleRemoveLocalStorage } =
    useUser();
    const { fetchCartQuantity,cartQuantity,setCartQuantity,handleQuantity } = useCart();
    const { setcityName, globalSearchTerm, setGlobalSearchTerm, setSessionCode, setUserId, setUsername, setUtmSessionId ,fetchCsrfToken} = useUser();
  useEffect(() => {
    fetchSeoMetaDetails()
    sessionStorage.removeItem("requestData");
    sessionStorage.removeItem("categoryType");
    sessionStorage.removeItem('categoryId');
    sessionStorage.removeItem('productId');
   
  }, []);

  useEffect(() => {
    const isSessionHandled = sessionStorage.getItem("sessionHandled");
  
    // If the session was already handled, avoid running this logic again
    if (isSessionHandled) return;
  
    // console.log("------>>>>>>>>>>>>>>>>>aboutus-------", checkSessionTokenExpirationStatus());
  
    if (checkSessionTokenExpirationStatus()) {
      // Clear session-related operations
      handleQuantity();
      handleRemoveLocalStorage();
  
      // Set the sessionHandled flag to true to prevent re-execution after reload
      sessionStorage.setItem("sessionHandled", "true");
  
      // Redirect to the homepage
      navigate("/");
  
      // Reload the page to clear cache
      window.location.reload();
    }
  }, []);

  const fetchSeoMetaDetails = async () => {
    try {
        const code = 'terms_of_use_page'
        const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json"
      
            },
            credentials: "include",
            mode:"cors"                  
          }
        );
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
    } catch (error) {
        //console.error('Error fetching categories:', error);
    }
  };
  
  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title
        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };
  return (
    <div>
      <Header />
      <main className="main-content-terms-of-use">
      <div className="section_breadcrumb">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <a >Terms and Conditions</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
        <div className="container mt-5-">
          <div className="term-use-section">
            <h2>Terms and Conditions</h2>
            <h3>Introduction</h3>
            <p>
              This document is an electronic record, in form of an electronic
              contract, as per the Information Technology Act, 2000 and rules
              made thereunder (as amended from time to time) and does not
              require any physical or digital signature.
            </p>
            <p>
              This Website www.selsmart.in (“<strong>Website</strong>”) is
              owned, maintained, and operated by Attero Recycling Private
              Limited (“<strong>We</strong>”, “<strong>Our</strong>” “
              <strong>Us</strong>”), a company incorporated under the laws of
              India, having its registered office at 2, C/o Saraswati Press,
              Green Park, Dehradun 248001, Uttarakhand, India and corporate
              office at A-72/A, Sector-64, Noida 201301, Uttar Pradesh, India.
              For the purpose of these Terms and Conditions, wherever the
              context so requires “<strong>You</strong>” or “
              <strong>Your</strong>” or “<strong>Yours</strong>” shall mean any
              natural or legal person who accesses or uses Our Website.
            </p>
            <p>
              We understand that, selling used electronic or electrical products
              can be a hassle, which is why through this Website, We provide You
              an online platform to sell Your used electronic or electrical
              products, conveniently and effortlessly from the comfort of Your
              home or office.
            </p>
            <p>
              These Terms and Conditions govern Your access and usage of Our
              Website. By accessing or using Our Website, You agree to be bound
              by these Terms and Conditions. We may modify the Terms and
              Conditions from time to time, with or without issuing You a
              notice. Your continued access or usage of this Website signifies
              Your acceptance of the updated Terms and Conditions. We request
              You to kindly check this webpage periodically to review the most
              current version of the Terms and Conditions. You also agree to be
              bound by Our policies, including but not limited to Privacy
              Policy, Shipping Policy and Cancellation Policy or Our any other
              policies or guidelines which may be updated from time to time.
            </p>
            <p>
              Please read these Terms and Conditions and the Privacy Policy
              carefully before using Our Website. If You do not agree with these
              Terms and Conditions, then You may not use this Website or avail
              any of its services. Without any notice, We may modify the
              contents or suspend the operations of the Website for support or
              maintenance purpose, or for other reason, at any time.
            </p>
          </div>
          <div className="term-use-section">
            <h3>Account Registration and Obligations</h3>
            <h4>1. User Account:</h4>
            <p>
              In order to sell Your used electronic or electrical products
              and/or avail Our services, You have to first create Your account
              by registering on Our Website. Please note that, We do not charge
              any fee from You for browsing Our Website, or creating an account,
              or availing any services of Our Website. You can create an account
              on Our Website through Your registered phone number and the one
              time password (OTP). Following Your successful registration, an
              account will be created by Us for You. Once an account is created,
              You can change, update or edit Your Personal Information as and
              when required.
            </p>
            <p>
              By creating an account with Us, You represent and Warrant that:
              (a) You are at least 18 years old and have legal capacity to enter
              into a binding agreement; (b) You will provide us with accurate,
              current and complete information, and will keep Your information
              updated; (c) Your registration and use of Our Website and/or
              services are not prohibited under any applicable law.
            </p>
            <p>
              Please note that, We reserve the right to suspend or terminate
              Your account, or Your access to the Website and or services, in
              the event that You breach any of the Terms and Conditions or any
              other applicable policies.
            </p>
            <h4>2. Account Security:</h4>
            <p>
              You are solely responsible for keeping Your account credentials
              confidential and secure and for all activities irrespective of
              whether taken by You or by any third party using Your account
              credentials.
            </p>

            <h4>3. Age Requirement:</h4>
            <p>
              Our Website and services are available only to the person who can
              as per Indian Contract Act, 1872 enter into a legally binding
              agreement. Persons who are “incompetent to contract” within the
              meaning of the Indian Contract Act, 1872 are not eligible to use
              the Website. If You are a minor i.e. under the age of 18 years,
              You shall not use or create an account on the Website.
            </p>
            <p>
              As a minor, if You wish to access or use the Website, such access
              or use may be undertaken by Your legal guardian or parents. We
              reserve the right to suspend or terminate Your account and / or
              refuse to provide You the access to the Website or services, if it
              is brought to Our notice or if it is discovered that You are under
              the age of 18 years and You are using this Website without
              parental or legal guardian’s supervision.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Limited Use and Intellectual Property Rights</h3>
            <p>
              Unless otherwise stated, copyright and all intellectual property
              rights in all information, documents, and related graphics
              published on the Website, including but not limited to text,
              audio, video or graphical image, trademarks and logos appearing on
              the Website are the sole property of Attero Recycling Private
              Limited, its affiliate, associates or licensors and are protected
              under applicable laws, except for information provided by
              third-party providers under contract to Us or affiliates. You
              undertake to not use any technology to enclose any trademark or
              logo or other proprietary information of Us, nor will You remove,
              conceal or obliterate to enclose any trademark or logo or other
              proprietary information belonging to Us or remove, conceal or
              obliterate any copyright or other proprietary notice including
              without limitation, the size, colour, location or style of all
              proprietary marks. Any infringement shall be vigorously defended
              and pursued to the fullest extent permissible under law.
            </p>
            <p>
              We authorize You to access, view and use Our Website, its content,
              and the software (collectively, the “Our Property”) solely to the
              extent necessary for You to avail Our services. You shall not
              remove any copyright, trademark or other proprietary notices that
              have been placed on Our Property.
            </p>
            <p>
              Except expressly permitted under these Terms and Conditions, any
              modification, reproduction, redistribution, republication,
              uploading, posting, transmitting, distributing or otherwise
              exploiting in any way Our Property, or any portion of Our
              Property, is strictly prohibited without Our prior written
              permission. Any violation of these restrictions may result in a
              copyright, trademark, or other intellectual property right
              infringement that may subject You to civil and/or criminal
              penalties.
            </p>
            <p>
              Other marks on the Website not owned by Us may be under license
              from the trademark owner thereof, in which case such license is
              for the exclusive benefit and use by Us unless otherwise stated or
              may be the property of their respective owners. You may not use
              any of the trademark name, logos, trademarks or brands, or
              trademarks or brands of others on the Website without Our prior
              written permission.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Payment</h3>
            <p>
              Once the sale of electrical or electronic products are finalized
              and price has been determined, We will initiate the payment
              process, based on the payment information You provided. By
              providing Your payment information, You authorize us to make the
              payment to You, and deduct any applicable taxes, fees, and/or
              collection costs. Please ensure that the payment information You
              provide is accurate and up to date to facilitate a smooth
              transaction process.
            </p>
            <p>
              We use the services of our partnered payment service provider to
              make safe and secure payments to You. By proceeding with a
              transaction, You authorize Us to securely transmit Your payment
              information to our partnered payment service provider for the
              purpose of completing the transaction. We request You to kindly
              read the terms and conditions and privacy policy of Our partnered
              payment service provider i.e. Razorpay.
            </p>
            <p>
              We are not responsible for the actions or policies of partnered
              payment service provider.
              <br /> You acknowledge that all transactions are subject to
              validation and authorization by Your bank. All prices for products
              listed on Our Website are displayed in Indian Rupees. We reserve
              the right to change the pricing of the products at Our sole
              discretion.
            </p>
            <p>
              While making payment to You, We will not be responsible or assume
              any liability, whatsoever in respect of any loss or damage arising
              directly or indirectly to You.
              <br />
              By accessing or using the Website or services, You agree to abide
              by all the applicable laws and regulations, including but not
              limited to Information and Technology Act, 2000 and the rules made
              thereunder, as amended from time to time.
            </p>
          </div>
          <div className="term-use-section">
            <h3>Representations and Warranties</h3>
            <p>You hereby represent and warrant to Us that:</p>
            <ul className="custom-list">
              <li>
                You are the lawful owner of the electrical or electronic
                products that You intend to sell.
              </li>
              <li>
                Your use of the Website and/or Our services will not violate any
                applicable law or regulation.
              </li>
              <li>
                All information that is submitted to Us in connection with Your
                account, is true, accurate and lawful.
              </li>
              <li>
                You agree that if You provide any information that is untrue,
                inaccurate, or incomplete or We have reasonable grounds to
                suspect that such information is untrue, inaccurate, or
                incomplete, or not in accordance with this Terms and Conditions,
                We shall have the right to indefinitely suspend or terminate or
                block access of Your account on the Website and refuse to
                provide You the access to the Website.
              </li>
              <li>
                You will (a) immediately inform Us of any unauthorized use of
                Your account or any other security breach and (b) ensure that
                You log out of Your account at the end of each session. We, Our
                employees, agents, directors and officers will not be held
                liable for any loss or direct or indirect damage arising from
                Your failure to comply with these Terms and Conditions. You may
                be held liable for any losses incurred to Us or any other user
                of the Website due to unauthorized use of their account by You.
              </li>
              <li>
                You shall not by means of any deep-link, page-scrape, spider or
                any other tool, program or algorithm or by any comparable manual
                process access, acquire, copy or monitor any part of Our Website
                or any content published on Our Website, or in any way reproduce
                or circumvent the structure of Our Website, so as to obtain or
                attempt to obtain any materials, documents, or information
                through any means that is not made available to You through Our
                Website.
              </li>
              <li>
                You agree not to use hacking, password mining or any other
                illegal or unethical means to obtain unauthorized access to Our
                Website, any system or network connected to Our Website, any
                server, computer, or any of the services provided on or through
                Our Website.
              </li>
              <li>
                You undertake that neither Our Website not any network connected
                to it shall be probed, scanned or tested, nor any security or
                authentical methods will be circumvented by You. You agree that
                You are prohibited from undertaking any reverse look-up, trace
                or seek to trace information of the users of Our Website.
              </li>
              <li>
                You shall not make any disparaging, defamatory or negative
                statement(s) or comment(s) about Us, Our brand name, or Our
                domain name.
              </li>
              <li>
                You shall not engage in any conduct or action that might harm
                Our or Our associate company’s image or reputation or otherwise
                tarnish or dilute any of Our trade or service marks, trade name
                or goodwill associated with such trade or service marks, trade
                names.
              </li>
              <li>
                You undertake not to do anything which may place an unreasonable
                or excessive burden on Our Website’s infrastructure, Our
                information technology systems, and networks, or nay systems or
                networks which are connected to Our Website.
              </li>
              <li>
                You shall not interfere or attempt to disrupt the intended
                functioning or transaction of Our Website.
              </li>
              <li>
                You agree that forging headers or manipulating identifiers to
                mask or cover the origin of any message or transmittal You send
                to Us on or through the Website or any service offered on or
                through the Website is prohibited.
              </li>
              <li>
                You agree not to impersonate any other individual or entity.
              </li>
              <li>
                You agree that You are prohibited from using the Website or its
                contents for any unlawful purpose or manner that violates these
                Terms and Conditions. This includes soliciting the performance
                of illegal activities or any actions that infringe Our rights.
              </li>
              <li>
                You agree that You are prohibited from engaging in any form of
                commercial advertising or solicitation directed towards other
                users of Our Website. This includes promoting the sale of any
                electrical or electronic products, whether directly related to
                those offered on the Website or otherwise related to Us.
              </li>
              <li>
                You acknowledge and agree that We are entitled to disclose any
                information at any time, in order to comply with any applicable
                law, regulation or government or court order or if we believe
                disclosing the information to the law enforcement agency is in
                the interest of public welfare or is necessary for prevention or
                investigate of any illegal activity.
              </li>
              <li>
                Website may contain offensive or obscene material posted by
                unauthorized users or hackers. You acknowledge the possibility
                of involuntary exposure to such content. In such situation We
                shall not be liable or responsible.
              </li>
              <li>
                We have all the rights to take necessary action and claim
                damages that may occur due to Your involvement/participation in
                any way on Your own or through group/s of people, intentionally
                or unintentionally in DoS/DDoS (Distributed Denial of Services).
              </li>
              <li>
                Subject to the Terms and Conditions, You shall not use any
                portion of the Website or any content which is made available on
                the Website, in any way (including mirroring) to any other
                computer, server, website or any other medium for publication or
                distribution or for any commercial purpose, without Our prior
                written consent.
              </li>
              <li>
                You may use the content made available on the Website for
                downloading, provided that You agree that: (a) You will not
                remove any proprietary notice in such documents; (b) You will
                use such information only for your personal, non-commercial
                purpose; (c) You will not copy or post such information on any
                networked computer or broadcast it in any media; (c) You will
                make no modifications to any such information, and (d) You will
                not make any representations or warranties relating to such
                documents.
              </li>
              <li>
                You understand and agree that while we strive to ensure
                uninterrupted availability and error-free delivery of the
                Website, due to the nature of the internet, this cannot be
                guaranteed. At any time and without prior notice, the Website
                may suspend or restrict Your access for upkeep, repairs, or for
                addition of new features or services.
              </li>
              <li>
                You shall not and shall not attempt, to: (a) resell or use any
                part of the Website for commercial purpose; or (b) use the
                Website or its content in a derivative manner; or (c) transfer
                any rights with respect to the Website; or (d) display the name,
                logo, trademark or other identifier of any other person in such
                a manner as to give the viewer of the Website the impression
                that such other person is a publisher or distributor of the
                Services on the Website; or (e) use any data gathering or
                extraction tools or meta tags.
              </li>
            </ul>
          </div>

          <div className="term-use-section">
            <h3>Warranty, Exclusions and Limitations of Liability</h3>
            <p>
              Our Property and all the materials/ information/ content and
              services made available to You are provided on “as is” and “as
              available” basis without any representation or warranty, express
              or implied, including all warranties of merchantability, fitness
              for a particular purpose, title, non-infringement, and any and all
              warranties arising from course of accessing or using Our Property
              or services; That the information on this Website is complete,
              true, accurate or non-misleading; That Our Property and services
              will meet your requirements, will always be available, accessible,
              uninterrupted, timely, secure or operate without error, as to the
              results that may be obtained from the operation, use or other
              exploitation of Our Property or services, and as to the accuracy
              or reliability of any information obtained from Our Property or
              services.
            </p>
            <p>
              We have partnered with logistics service partner to facilitate
              safe and secure collection of Your electrical or electronic
              products from Your requested location. We ensure that the Product
              collection executives of logistics service provider are
              individuals with highest regard for ethics and integrity. However,
              it is not possible for Us to ensure that logistics service
              provider’s Product collection executives will behave consistently
              demonstrate professionalism, competence, and good manners. We
              hereby clarify that any ill-mannerism, impoliteness, discourtesy,
              or offensiveness shown by logistics service provider’s Product
              collection executives is beyond Our control and any issue arising
              between You and Our logistics service provider’s Product
              collection executive will have to be resolved by You
              independently.
            </p>
            <p>
              We are under no circumstances liable to You for any incidental,
              consequential, indirect, punitive or special damages (including
              damages for loss of business, loss of profits or loss of use),
              whether based on contract, tort (including negligence), or
              otherwise arising from or relating to the Our Property or
              services. In any event, Our maximum aggregate liability for any
              and all damages arising from the Our Property or services shall be
              a refund of the amount paid by You to Us, if any.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Indemnity</h3>
            <p>
              You agree to indemnify and hold Us, Our affiliates, suppliers,
              licensors and partners, and the officers, directors, employees,
              agents and representatives of each of them harmless, from any
              claim or demand including costs, liabilities and legal fees, from
              any claim or demand made by any third party due to or arising out
              of (i) Your access or usage of Our Property or services, (ii) Your
              violation of these Terms and Conditions and Privacy Policy, or
              (iii) Infringement by You, or any third party using Your account,
              of any intellectual property or other right of any person or
              entity.
            </p>
            <p>
              In the event of any claim, lawsuit, or proceeding for which You
              are obligated to indemnify Us under these Terms and Conditions, We
              reserve the right to assume exclusive control and defense of such
              matters, at Your expense. You agree to cooperate fully with Our
              defense of such claims. Furthermore, You agree to refrain from
              settling any such matter without Our prior written consent. We
              will make reasonable efforts to notify You upon becoming aware of
              any such claim, action, or proceeding.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Termination</h3>
            <p>
              We may suspend or terminate Your use of Our Website or any service
              if We believe, in our sole and absolute discretion that You have
              infringed, breached, violated, abused, or unethically manipulated
              or exploited any terms of these Terms and Conditions. However,
              these Terms and Conditions will survive indefinitely until We
              choose to terminate them.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Information Collection and Sharing</h3>
            <p>
              By sharing Your information with Us, You understand that You may
              be contacted by Our representative via telephone, email, text, or
              prerecorded message regarding Our services, programs, offers,
              events, announcements, and offers from Our third party marketing
              partners. If You respond to any such offer, Your information may
              be subject to that third party’s terms and conditions and privacy
              policy. By providing Us Your phone number, You grant Us permission
              for the use of text messages, prerecorded voice or and/or
              automatic telephone dialling systems to contact you and/or deliver
              Our related information, offers or announcements.
            </p>
            <p>
              You can opt out from Our email and messaging services at any time
              by writing to <a href="mailto:care@selsmart.in">care@selsmart.in</a> with opt out email in the subject.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Privacy</h3>
            <p>
              Your Personal Information and its security are paramount to Us. We
              collect, process, store and share Your Personal Information, on
              Our information technology systems that may be protected by
              physical as well as reasonable technological security measures and
              procedures as per Information Technology Act 2000 and Rules made
              there under.
            </p>
            <p>
              Our Privacy Policy is available at 
              <Link to="/privacy-policy">Click here</Link>. Please read Our
              Privacy Policy, as it contains important information relating to
              Your use of the Website and services.
            </p>
            <p>
              We may share / sell / transfer some or all of Your Personal
              Information with another business entity in the event of a merger,
              acquisition, re-organization, amalgamation, restructuring, or any
              other reason. Nevertheless, in such events, the other business
              entity or the new combined entity will comply with Our Privacy
              Policy.
            </p>
            <p>
              If You object to Your Information being collected, processed,
              stored or shared in the way as outlined in Our Privacy Policy then
              You shall not use Our Website.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Disclaimer</h3>
            <p>You understand, acknowledge and agree that: </p>
            <ul className="custom-list">
              <li>
                We make no representations or warranties of any kind or nature
                with respect to the information or content posted on this
                Website.
              </li>
              <li>
                We disclaim all liability and provides no warranties for the
                correctness, efficacy, timeliness, or suitability of any data or
                content obtained from third-party sources, including any
                hyperlinks to or from such websites.
              </li>
              <li>
                In no event shall We be liable for any damages of any kind or
                nature, including, without limitation, direct, indirect,
                consequential, incidental or special (including loss of profit)
                damages arising from or in connection with the information or
                content posted on this Website.
              </li>
              <li>
                We do not warrant the accuracy or completeness of the Our
                Property or services, or the uptime of Our Website, or the
                reliability of any advice, opinion, statement, or other
                information displayed or distributed through the Website. You
                acknowledge that any reliance on any such opinion, advice,
                statement, memorandum, or information shall be at Your sole
                risk. We reserve the right, in Our sole discretion, to correct
                any errors or omissions in any portion of the Website. We may
                make any other changes to Our Property, products, programs,
                services or prices (if any) described on the Website at any time
                without notice.
              </li>
            </ul>
          </div>

          <div className="term-use-section">
            <h3>Authorization for Communication and Notification</h3>
            <p>
              By accepting the Terms and Conditions, You agree and understand
              that You hereby give Your express consent to receive various
              alerts, information, promotional and/or marketing and/or any other
              commercial communications on the telephone number provided by You,
              either from Us or through any designated third party service
              provider via different modes including but not limited to SMS,
              telephonic call, email etc as and when We require. Furthermore,
              the consent provided by You for the aforementioned purpose shall
              remain in effect irrespective of whether Your telephone number is
              registered with the National Do Not Call Registry or listed in the
              National Customer Preference Register.
            </p>
            <p>
              Moreover, by providing this consent, You acknowledge and agree
              that You will not hold Us or Our third party service providers
              responsible for any commercial communication as provided under
              Telecom Commercial Communications Customer Preference (TRAI)
              Regulations, 2018, or any other applicable regulations, including
              subsequent amendments.
            </p>
            <p>
              The consent provided hereunder will be automatically renewed every
              month. However, You can stop or unsubscribe/ opt-out from
              receiving marketing/ promotional communications, and other
              commercial communication from Us at any time by writing email to
              Us at <a href="mailto:care@selsmart.in">care@selsmart.in</a> before the due date of renewal of consent.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Third-Party Links</h3>
            <p>
              Our Website may contain links to the websites which are operated
              and owned by third parties. We do not have any control over such
              third-party websites and We are not responsible for their content,
              privacy policies or operations. You acknowledge and agree that We
              shall have no liability for any harm or loss resulting from, or
              allegedly resulting from the use of or reliance on any such goods
              or services available on or through any such third-party websites.
            </p>
            <p>
              We do not warrant the offerings of any third-party websites or
              services or the accuracy, completeness, or reliability of any
              information, material, product, or service displayed or offered
              through such websites or services. Linke to third party websites
              or services do not imply any endorsement by Us of such websites or
              services or the content, products or services available through
              them. We strongly encourage You to read the terms and conditions
              and privacy policies of any third-party website or services that
              You visit.
            </p>
            <p>
              We reserve the right to modify, add or remove links to third party
              websites or services at any time without any prior written notice.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Governing Law and Jurisdiction</h3>
            <p>
              There Terms and Conditions will be governed by the laws of
              Republic of India and all claims arising from or relating to the
              operation, use of the Website and/or the services will subject to
              the courts at New Delhi, India.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Access Outside the Republic of India</h3>
            <p>
              We make no representation that the content on Our Website is
              appropriate to be used of accessed outside the Republic of India.
              Your use of or access to the Website from outside the Republic of
              India is at Your own risk and You are responsible for compliance
              with the laws of such jurisdiction.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Waiver</h3>
            <p>
              Our failure to enforce any right or provision of these Terms and
              Conditions will not be deemed a waiver of such right or provision.
              No waiver by Us shall be effective unless it is in writing and
              signed by Us.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Force Majeure</h3>
            <p>
              We will not be held responsible or liable for any delay or failure
              in performance of Our obligations under these Terms and Conditions
              caused by or resulting from any force majeure event.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Severability</h3>
            <p>
              If any provision of these Terms and Conditions is held to be
              invalid or unenforceable by a court of competent jurisdiction,
              then the remaining provisions will nevertheless remain in full
              force and effect.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Entire Agreement</h3>
            <p>
              These Terms and conditions set forth the entire agreement between
              You and Us and supersedes all prior promises, agreements or
              representations, whether written or oral, regarding such subject
              matter. You agree that the electronic text of these Terms and
              Conditions constitutes writing and Your assent to the Terms and
              Conditions hereof constitutes a “signing” for all purposes.
            </p>
          </div>

          <div className="term-use-section">
            <h3>Grievance Redressal</h3>
            <p>
              Any complaint, abuse, or concerns with regards to the content and
              or breach of these terms shall be immediately informed to the
              designated grievance officer as mentioned below via in writing or
              through email to: 
              <a href="mailto:care@selsmart.in">care@selsmart.in</a>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfUsePage;
